import React from 'react';

import DateFilter from 'bundles/apex/custom_fields/filters/date_filter';
import NumberFilter from 'bundles/apex/custom_fields/filters/number_filter';
import SelectFilter from 'bundles/apex/custom_fields/filters/select_filter';
import StringFilter from 'bundles/apex/custom_fields/filters/string_filter';

import type { CustomFieldSchema } from 'bundles/crm/types';
import type { Filter, Filters } from './types';

const componentsByValueType = {
  date: DateFilter,
  enum_value: SelectFilter,
  float: NumberFilter,
  string: StringFilter,
};

interface Props {
  changeFilter: (filter: Partial<Filters>) => void;
  filter: Filter;
  schema: CustomFieldSchema;
}

export default function CompsCustomFieldFilter({ changeFilter, filter, schema }: Props) {
  const Component = componentsByValueType[schema.valueType] || StringFilter;

  return (
    <Component
      filter={filter}
      schema={schema}
      onChange={filter => changeFilter({ [schema.slug]: filter })}
    />
  );
}
